import { THEME } from 'bora-material-ui/themes'

export const isGavdos = window.brandProps.theme === THEME.GAVDOS

export const getGavdosStyle = (gavdosStyle, defaultStyle) => (isGavdos ? gavdosStyle : defaultStyle)
